module.exports = __webpack_public_path__ + "assets/img/en-d8111357.png";